<template>
    <form class="container mt-8 ">
         <h1 class="title3"> TYPE DE SERVICE :</h1>
         <p><strong>{{ demande.serviceType }}</strong></p>
         <h1 class="title3">DATE DU SERVICE VOULU:</h1>
         <p><strong>{{ demande.date }}</strong></p>
         <h1 class="title3">Email</h1>
         <p><strong>{{ demande.email }}</strong></p>
         <h1 class="title3">Numéro de téléphone :</h1>
         <p><strong>{{ demande.phoneNumber }}</strong></p>
         <h1 class="title3">Informations sur votre société:</h1>
         <p><strong>{{ demande.societyInfo }}</strong></p>
         <h1 class="title3">Informations sur le projet que vous voulez atteindre avec notre société:</h1>
         <p><strong>{{ demande.projectInfo }}</strong></p>
         <button type="button" class="btn btn-light me-2" v-on:click="deleteDemande" >Delete</button>
        <button type="button" class="btn btn-light" v-on:click="$emit('cancel' , {})">Cancel</button>
     </form> 
 </template>
 
<script >
import axios from "axios";
import APIs from "@/../config";
export default {
    name : "DemandeDetails",
    data(){
        
    },
    props : {
        demande : Object
    },
    methods : {
        deleteDemande(){
            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')  
            this.$swal.fire({
            title: 'Voulez-vous vraiment supprimer',
            text: "",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, suprimer'
            }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${APIs.API_URL}/demande/${user_id}/${this.demande._id}`,{
                headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${get_token}`
                }
            })
                .then(() => {
                    this.$swal.fire(
                    'supprimée',
                    '',
                    'success'
                    )
                    this.$emit("refresh")
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
            })
        }
    }
}
</script>
 <style lang="scss" scoped>
 .title{
   color:white;
 }
 .title2{
   color:black;
   font-size: 30px;
 }
 .title3{
   color:#8E7136;
   font-size: 25px;
 }
 .title4{
   color:black;
   font-size: 20px;
 }
 .title5{
     color:#A68D5B;
     font-size: 16px;
 }
 .box{
   width: 80%;
   border-radius: 6px;
   color: black;
   border: 1px solid black;
   margin-bottom: 2%;
   text-align: center;
   padding: 1%;
 }
 .box5{
       border: 2px solid #A68D5B;
       height:40px;
 }
 .boxarea{
     width: 80%;
     height:200px;
     border-radius: 6px;
     color: black;
     border: 2px solid #A68D5B;
     margin-bottom: 2%;
     text-align: center;
     padding: 1%;
 }
 .enregistrer{
     margin-right: 10%;
     display: flex;
     justify-content: center;
 }
 .row2{
     display: flex;
     justify-content:space-between;
     .col2{
         .group2{
             margin-bottom: 6%;
             label{
                 font-size:15px;
                 color:#A68D5B;
             }
 
             input{
                 margin-bottom: 1%;
                 outline:none;
                 border:2px solid #A68D5B;
                 border-radius:6px;
                 color:black;
                 padding:2px;
                 width: 85%;
                 height:38px;
             }
             textarea{
                 outline:none;
                 border:2px solid #A68D5B;
                 border-radius:6px;
                 color:black;
                 padding:2px;
                 width:90%;
             }
         }
     }
 }
 </style>